/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx';
import { PdpType } from 'lib/apis/services/PdpSingle';
import { useMemo } from 'react';

interface Props {
  images: string[];
}

function ImageGalleryTiles({ images }: Props) {
  const otherImages = useMemo(() => {
    if (images) {
      const midPoint = Math.ceil(images.length / 2);
      return [images.slice(0, midPoint), images.slice(midPoint, images.length)];
    }

    return [];
  }, [JSON.stringify(images)]);

  return (
    <>
      {/*این قسمت برای نمایش عکس کاور استفاده می شد*/}
      {/*{cover && (*/}
      {/*  <div*/}
      {/*    key={cover.photoLargeUrl}*/}
      {/*    className={clsx('pb-4', {*/}
      {/*      'col-span-2': cover.isCover,*/}
      {/*    })}*/}
      {/*  >*/}
      {/*    <img*/}
      {/*      src={cover.photoLargeUrl}*/}
      {/*      className="h-auto min-w-full border rounded-xs border-grey-200"*/}
      {/*      alt=""*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*)}*/}
      <div className="gap-4 md:columns-2 columns-1">
        {otherImages.map((col, index) => (
          <div className="grid gap-4 pb-4 md:pd-0 last:pb-0" key={index}>
            {col.map((image) => (
              <div key={image}>
                <img
                  src={image+"?q=original"}
                  className="h-auto min-w-full border rounded-xs border-grey-200"
                  alt=""
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}

export default ImageGalleryTiles;
